/* eslint-disable prettier/prettier */
import "zone.js"; // Required for Angular
// import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
// import AppModule from "./app/app.module";
import { MsgService } from "./utils/msg.service";
// import { Config } from "./utils/config";
import { Util } from "./utils/util";
import { Xl } from "./utils/xl";

/* global, document */
// declare const Excel: any;
declare const $: any;
declare const document: Document;
declare const Office: any;
declare const crypto: any;
var xl = new Xl();
var msg = new MsgService();
var errorMessage = "An error occurred";

const commands = [
  { type: 'data', name: 'Set Guid', action: 'guid' },
  { type: 'data', name: 'Num to Word', action: 'numToWord' },
  { type: 'data', name: 'Random String', action: 'randomString' },
  { type: 'data', name: 'Lower Case', action: 'lower' },
  { type: 'data', name: 'Upper Case', action: 'upper' },
  { type: 'data', name: 'Title Case', action: 'title' },
  { type: 'data', name: 'Camel Case', action: 'camel' },
  { type: 'data', name: 'Pascal Case', action: 'pascal' },
  { type: 'data', name: 'Underscore Case', action: 'underscore' },
  { type: 'data', name: 'Trim', action: 'trim' },

  { type: 'date', name: 'Today', action: 'today' },
  { type: 'date', name: 'Today (SQL)', action: 'todaySql' },
  { type: 'date', name: 'Tomorrow', action: 'tomorrow' },
  { type: 'date', name: 'Yesterday', action: 'yesterday' },
  { type: 'date', name: 'Dates', action: 'dates' },
  { type: 'date', name: 'Time', action: 'time' },

  { type: 'sql', name: 'Load Data', action: 'loadData' },
  { type: 'sql', name: 'View Tables', action: 'viewTables' },
  { type: 'sql', name: 'Insert', action: 'insert' },
  { type: 'sql', name: 'Insert Query', action: 'insertQuery' },
  { type: 'sql', name: 'Update', action: 'update' },
  { type: 'sql', name: 'Update Query', action: 'updateQuery' },
  { type: 'sql', name: 'Create Table', action: 'createTable' },
  { type: 'sql', name: 'Table Query', action: 'createTableQuery' },
  { type: 'sql', name: 'Add Column', action: 'addColumnQuery' },
  { type: 'sql', name: 'Rename Column', action: 'renameColumnQuery' },

  { type: 'date', name: 'Format Date', action: 'formatInvoice' },
  // { type: 'invoice', name: 'Save PDF', action: 'savePDF' },
];


Office.onReady(() => {
  document.getElementById("sideload-msg").style.display = "none";
  xl.loadConnectionString();
  setError(xl.errorMessage);
  // document.getElementById('btnRun').onclick = sayHello; // () => { msg.info("Run button clicked"); };
  // Filter and render commands by type
  try {
    let groups = commands.reduce((groups, item) => {
      groups[item.type] = groups[item.type] || [];
      groups[item.type].push(item);
      return groups;
    }, {});

    Object.keys(groups).forEach(key => {
      if (groups[key].length > 0) {
        renderUICommands(key, groups[key], "commands", handleCommandClick);
      }
    });
  } catch (error) {
    setError(errorMessage);
  }
});

function renderUICommands(name, commands, containerId, onClickHandler) {
  const container = $(`#${containerId}`);

  const newDiv = $('<div>', {
    class: 'row mb-3',
    html: `<h5 class="border-bottom mb-2">${Util.titleCase(name)}</h5>`
  });

  commands.forEach(item => {
    const buttonWrapper = document.createElement("div");
    buttonWrapper.className = "col-6 col-md-3 col-lg-2";
    buttonWrapper.innerHTML = `
    <button class="btn btn-outline-primary btn-block">
    ${item.name}
    </button>
    `;
    buttonWrapper.querySelector("button").onclick = () => onClickHandler(item.action);
    newDiv.append(buttonWrapper);
  });
  container.append(newDiv);
}

// function renderCommands(commands, containerId, onClickHandler) {
//   const container = document.getElementById(containerId);
//   commands.forEach(item => {
//     const buttonWrapper = document.createElement("div");
//     buttonWrapper.className = "col-6 col-md-3 col-lg-2";
//     buttonWrapper.innerHTML = `
//         <button class="btn btn-outline-primary btn-block">
//             ${item.name}
//         </button>
//     `;
//     buttonWrapper.querySelector("button").onclick = () => onClickHandler(item.action);
//     container.appendChild(buttonWrapper);
//   });
// }

function handleCommandClick(actionName) {
  // console.log("Command action:", actionName);
  // msg.info("Command action: " + actionName);

  switch (actionName) {
    case 'guid': xl.setValues(() => crypto.randomUUID());
      break;
    case 'numToWord': xl.setValues((x: string) => Util.numToWords(+x || 0));
      break;
    case 'randomString': xl.setValues((x) => Util.randomString(+x || 8));
      break;
    case 'lower': xl.setValues((x: string) => x.toLowerCase());
      break;
    case 'upper': xl.setValues((x: string) => x.toUpperCase());
      break;
    case 'title': xl.setValues((x: string) => Util.titleCase(x));
      break;
    case 'camel': xl.setValues((x: string) => Util.camelCase(x));
      break;
    case 'pascal': xl.setValues((x: string) => Util.pascalCase(x).replace(' ', ''));
      break;
    case 'underscore': xl.setValues((x: string) => Util.underscoreCase(x).replace(' ', ''));
      break;
    case 'trim': xl.setValues((x: string) => x.trim());
      break;

    case 'today': xl.setValues(() => Util.getDate());
      break;
    case 'todaySql': xl.setValues(() => {
      const d = new Date();
      return d.toISOString().split('T')[0];
    }
    );
      break;
    case 'tomorrow': xl.setValues(() => Util.getDate(1));
      break;
    case 'yesterday': xl.setValues(() => Util.getDate(-1));
      break;
    case 'dates': xl.setValues((x: string, rowIndex: number) => Util.getDate(rowIndex));
      break;
    case 'time': xl.setValues(() => new Date().toTimeString().slice(0, 5));
      break;

    case 'loadData': xl.loadData();
      break;
    // case 'viewTables': xl.viewTables();
    //   break;
    case 'insert': xl.getQuery('insert', (x) => xl.execute(x));
      break;
    case 'insertQuery': xl.getQuery('insert', (x) => xl.showDialog(x));
      break;
    case 'update': xl.getQuery('update', (x) => xl.execute(x));
      break;
    case 'updateQuery': xl.getQuery('update', (x) => xl.showDialog(x));
      break;
    case 'createTable': xl.getQuery('createTable', (x) => xl.showDialog(x));
      break;
    case 'createTableQuery': xl.getQuery('createTable', (x) => xl.showDialog(x));
      break;
    case 'addColumnQuery': xl.getQuery('addColumn', (x) => xl.showDialog(x));
      break;
    case 'renameColumnQuery': xl.getQuery('renameColumn', (x) => xl.showDialog(x));
      break;
    case 'formatInvoice': xl.setInvoice();
      break;
    case 'savePDF': xl.savePDF();
      break;
  };
  if (xl.errorMessage) setError(xl.errorMessage);
}

function setError(message) {
  const errorElement = document.getElementById("error-message");
  errorElement.innerHTML = message;
  msg.error(message);
}
